import { css } from "@emotion/react";
import type { Theme } from "@emotion/react";

import { ActiveStatusProps } from "../ActiveStatus";

export const wrapperStyle = () => {
	return css`
		position: relative;
		display: inline-flex;
	`;
};

export const dotStyle = (theme: Theme, position: ActiveStatusProps["position"]) => {
	return css`
		position: ${position ? "absolute" : "initial"};
		width: 6px;
		height: 6px;
		background: ${theme.colors.error_60_100};
		border-radius: 6px;
		transition: 0.25s all;
		${getPositionStyle(position)};
	`;
};

export const getPositionStyle = (position: ActiveStatusProps["position"]) => {
	let css;
	switch (position) {
		case "bottomLeft":
			css = {
				top: "-4px",
				left: "-4px"
			};
			break;
		case "bottomRight":
			css = {
				bottom: "-4px",
				right: "-4px"
			};
			break;
		case "topLeft":
			css = {
				top: "-4px",
				left: "-4px"
			};
			break;
		case "topRight":
			css = {
				top: "-4px",
				right: "-4px"
			};
			break;
		case "topCenter":
			css = {
				top: "-6px",
				left: "50%",
				transform: "translate(-50%)"
			};
			break;
		case "RightCenter":
			css = {
				top: "50%",
				right: "-10px",
				transform: "translateY(-50%)"
			};
			break;
	}
	return css;
};
